import React, { useEffect, useState } from 'react'; 
import {Button, Stack, Dialog, Table, TableBody,  TableCell, TableContainer, TableHead, TableRow, Typography, Box, DialogTitle} from "@mui/material";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useTranslation } from "react-i18next";




import { BatchUploadStlye } from "../../Bluetooth/BatchUploadStlye";

import { styled } from "@mui/material/styles";
import { Icon } from "@iconify/react";


import { PenStudentInfo } from '../../Bluetooth/PenStudentInfo';
import { usbDeviceEventBus } from "../USBEventTypes";
import { USBBatchProcessor } from "../Uploader/USBBatchProcessor";
import { UploadCallbacks } from "../Uploader/USBBatchStrokeUploader";
import { INcodeAllocationResponse } from '@/repositories/model/transfer/INcodeAllocationResponse';
import { IProjectSubmissionTransfer } from '@/repositories/model/transfer/IProjectSubmissionTransfer';
import { IUSBConnectedPen } from '@/neolab-libs/nl-lib3-common/interfaces/IUSBConnectedPen';
import { USBAssignedUserMapper } from '@/common/objects/USBAssignedUserMapping/USBAssignedUserMapper';
import { useStores } from '@/hooks/useStores';
import { IPageSOBP, NeoStroke } from '@/neolab-libs/nl-lib3-common';
import { NativeMethods } from '@/neolab-libs/nl-lib3-pengateway/src/nl-lib-native-methods/NativeMethods';
import { SendingPanel, SendingStatus } from './USBSendingPanel';
import { USBBatchUploadRow } from './USBBatchUploadRow';

type Props = {
  projectCode: string,
  templateProjectCode: string,
  open: boolean,
  ncodeAllocation: INcodeAllocationResponse,
  handleClose: () => void;
  projectSubmissionList: IProjectSubmissionTransfer[],

  refreshProjectSumissionList: () => void;

}

const PenDataInfo = styled(Stack)({
  gap: 40,
  alignItems: "center",
  justifyContent: "center",
  width: "40vw",
  backgroundColor: "rgba(17, 17, 17, 0.8)",
  '& .MuiDialogTitle-root': {
    textAlign: "center",
    color: "#fff",
    fontSize: "2rem",
    fontWeight: 800,
    lineHeight: "140%",
  },
});

const TableWrap = styled(Stack)({
  alignItems: "center",
  justifyContent: "center",
  padding: "0 30px",
  width: "60vw",
});

const TableContainerWrap = styled(TableContainer)({
  width: "70%",
  '& *':{
    fontSize: 16,
  },
  '& span':{
    position: 'relative',
  },
  '& .MuiTableHead-root': {
    fontSize: 16,
    color: '#111!important',
    background: '#E2E7E3',
    '& th':{
      borderBottom: 0,
      '&:nth-child(1)':{
        borderRadius: '8px 0 0 8px',
      },
      '&:nth-child(3)':{
        borderRadius: '0 8px 8px 0',
      },
    },
  },
  '& td':{
    color: '#fff',
    borderColor: '#757575',
    '&:nth-child(3)':{
      color: '#2F80ED',
    }
  },
  '& .no-data':{
    '& td':{
      color: '#757575!important',
      '& svg':{
        color: '#ff0000!important',
        position: 'absolute',
        right: -35,
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
      },
    }
  }
});


const TipBox = styled(Stack)({
  gap: 16,
  textAlign: "center",
  color: "#fff",
  padding: 24,
  borderRadius: 16,
  border: "1px solid #fff",
  '&.warning': {
    border: "1px solid #FF0000",
    backgroundColor: "rgba(255, 0, 0, 0.4)",
  },
});

const ButtonWrap = styled(Stack)({
  flexDirection: "row",
  gap: 16,
  'button': {
    fontSize: 16,
    borderRadius: 8,
    width: 170,
    height: 48,
  }
});

const CustomLinearProgress = styled(LinearProgress)(() => ({
  height: 20,
  borderRadius: 100,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#DEF8F5",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 100,
    backgroundColor: "#008C73",
  },
}));


export function USBBatchUploadDialog(props: Props) {

    const { projectSubmissionList, ncodeAllocation, projectCode, templateProjectCode, refreshProjectSumissionList } = props;
    const i18next = useTranslation();
    const [sendingStatus, setSendingStatus] = React.useState<SendingStatus>('idle'); // 상태 추가

    const [studentInfos, setStudentInfos] = React.useState<PenStudentInfo[]>([]);
    const [isCompleteDialogOpen, setIsCompleteDialogOpen] = React.useState(false);
    const [devices, setDevices] = React.useState<IUSBConnectedPen[]>([]);
    const usbAssignedUserMapper = React.useMemo(() => new USBAssignedUserMapper(), []);
    const { projectExamStore, projectSubmissionStore, projectStore, neoPenStore } = useStores();
  const [numOfReadyToUploadPen, setNumOfReadyToUploadPen] = React.useState<number>(0);
  const readyDeviceMacsRef = React.useRef<Set<string>>(new Set());
  const duplicateDeviceMacsRef = React.useRef<Set<string>>(new Set());
  const [numOfDuplicateSelection, setNumOfDuplicateSelection] = React.useState<number>(0);
  const [pipeline, setPipeline] = React.useState<{ current: number; total: number }>({ current: 0, total: 0 });
  const [itemsPerPhase, setItemsPerPhase] = React.useState<number>(0);
  const processorRef = React.useRef<USBBatchProcessor | null>(null);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = React.useState(false);
  const failedIndicesRef = React.useRef<number[]>([]);
  const lastUsbDeletedCountRef = React.useRef<number>(0);

    const onClose = () => {
        props.handleClose();
    };

  const handleSendClick = async () => {
    setSendingStatus('sending');
    lastUsbDeletedCountRef.current = 0;

    // Collect items from all rows via the EventBus
    const collected: Array<{ userCode: string, range: { start: IPageSOBP; end: IPageSOBP }, strokes: NeoStroke[], submissionCode?: string, mac: string }> = [];
    const unsubscribe = usbDeviceEventBus.on('usb-report-batch-item', (payload) => {
      if (payload?.item) {
        const { userCode, range, strokes, submissionCode } = payload.item;
        collected.push({ userCode, range, strokes, submissionCode, mac: payload.mac });
      }
    });

    // Ask all rows to report their current item (sync emit, rows respond immediately)
    usbDeviceEventBus.emit('usb-request-batch-items', {});

    // Log and cleanup
    console.log('[USBBatchUploadDialog_new2510] Collected items:', collected);
    unsubscribe();

    // Download projectExamList
    await projectExamStore.downloadProjectExamListAndStore(props.projectCode);
    if (projectExamStore.projectExamList == null || projectExamStore.projectExamList.length == 0) {
      return;
    }

    // Prepare items for batch processor (strip mac)
    const items = collected.map(({ mac, ...rest }) => rest);
    setItemsPerPhase(items.length);

    // Build callbacks to drive SendingPanel progress
    const callbacks: UploadCallbacks = {
      onStart: (t) => setPipeline({ current: 0, total: t }),
      onItemStart: (i) => setPipeline((prev) => ({ ...prev, current: i })),
      onProgress: (next, t) => setPipeline({ current: Math.min(next, t), total: t }),
      onItemSuccess: () => {},
      onItemError: () => {},
      onComplete: ({ failedIndices }) => {
        const hasFailure = Array.isArray(failedIndices) && failedIndices.length > 0;
        if (hasFailure) {
          failedIndicesRef.current = failedIndices ?? [];
          setSendingStatus('stoppedwithError');
          setIsErrorDialogOpen(true);
        }
      },
      onUsbStageComplete: (successCount, _failed) => {
        const start = Math.max(0, Math.min(lastUsbDeletedCountRef.current, items.length));
        const end = Math.max(start, Math.min(successCount, items.length));
        if (end > start) {
          const successMacs = collected
            .slice(start, Math.min(end, collected.length))
            .map((c) => c.mac)
            .filter((m) => !!m);
          if (successMacs.length > 0) {
            usbDeviceEventBus.emit('usb-request-delete-files', { macs: successMacs });
          }
          lastUsbDeletedCountRef.current = end;
        }
      },
      onCompleteHighLevel: (status) => {
        if (status === 'success') {
          setSendingStatus('completed');
          setIsCompleteDialogOpen(true);
        } else if (status === 'failure') {
          setSendingStatus('stoppedwithError');
          setIsErrorDialogOpen(true);
        }
      }
    };

    // Start processor
    processorRef.current = new USBBatchProcessor(
      props.projectCode,
      items,
      projectExamStore.projectExamList,
      projectSubmissionStore,
      projectStore,
      neoPenStore,
      callbacks,      
    );
    void processorRef.current.uploadStrokes();
  };

  
  // USB discovery: register callback and keep devices updated (no sorting)
  useEffect(() => {
    const callBackFunc = (args: { devices: IUSBConnectedPen[] }) => {
      const incoming = args?.devices ?? [];
      // de-dupe by mac
      const byMac = new Map<string, IUSBConnectedPen>();
      for (const d of incoming) {
        if (!d?.mac) continue;
        if (!byMac.has(d.mac)) byMac.set(d.mac, d);
      }
      setDevices(Array.from(byMac.values()));
    };

    try {
      NativeMethods.StartReadingUSBConnections({ callBackFunc });
    } catch (e) {
      console.log('StartReadingUSBConnections failed', e);
    }

    return () => {
      try {
        NativeMethods.StopReadingUSBConnections();
      } catch (e) {
        console.log('StopReadingUSBConnections failed', e);
      }
    };
  }, []);

  // Prune ready set when devices list changes (remove ready devices no longer present)
  useEffect(() => {
    const currentMacs = new Set((devices || []).map(d => d.mac));
    const setRef = readyDeviceMacsRef.current;
    let changed = false;
    for (const mac of Array.from(setRef)) {
      if (!currentMacs.has(mac)) {
        setRef.delete(mac);
        changed = true;
      }
    }
    if (changed) {
      setNumOfReadyToUploadPen(setRef.size);
    }
  }, [devices]);

  // Prune duplicate set when devices list changes (remove duplicates for disconnected devices)
  useEffect(() => {
    const currentMacs = new Set((devices || []).map(d => d.mac));
    const setRef = duplicateDeviceMacsRef.current;
    let changed = false;
    for (const mac of Array.from(setRef)) {
      if (!currentMacs.has(mac)) {
        setRef.delete(mac);
        changed = true;
      }
    }
    if (changed) {
      setNumOfDuplicateSelection(setRef.size);
    }
  }, [devices]);

  React.useEffect(() => {
      const s = projectSubmissionList.map((submission) => {
        return new PenStudentInfo(
          submission.userCode,
          submission.userProfile.name,
          submission.userProfile.school,
          submission.userProfile.grade,
          submission.userProfile.className,
          submission.userProfile.number,
          ""
        );
      });
  
      s.sort((a, b) => {
        if (a.grade < b.grade) return -1;
        if (a.grade > b.grade) return 1;
        if (a.className < b.className) return -1;
        if (a.className > b.className) return 1;
        if (a.number < b.number) return -1;
        if (a.number > b.number) return 1;
  
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
  
        return 0;
      });
  
      setStudentInfos(s);
  
    }, [projectSubmissionList])


  // 완료 모달 닫기
  const handleCompleteDialogClose = () => {
    setIsCompleteDialogOpen(false);
    onClose(); // 원래 다이얼로그도 닫기
  };

  const handleRetryFailed = () => {
    setIsErrorDialogOpen(false);
    setSendingStatus('sending');
    if (processorRef.current) {
      void processorRef.current.resume();
    }
  };



  return (
    <>
      <Dialog
        open={true}
        maxWidth={false} // 기본 maxWidth를 해제합니다.
        PaperProps={{
          sx: {
            backgroundColor: "rgba(17, 17, 17, 0.8)",
            margin: '0px',
            borderRadius: '0px',
            width: "100vw",
            height: "100vh",
            minWidth: "100vw",
            minHeight: "100vh",
          },
        }}>
        <Stack flexDirection="row" width="100%" height="100%">
          <TableWrap>
            <TableContainerWrap>
              <Table aria-label="simple table" width="auto!important">
                <TableHead>
                  <TableRow>
                    <TableCell width='3%' align="center">
                      {i18next.t("펜 ID")}
                    </TableCell>

                    <TableCell width='5%' align="center">
                      {i18next.t("학생명 (학년/반/번호)")}
                    </TableCell>

                    <TableCell width='7%' align="center">
                      {i18next.t("데이터 상태")}
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {devices.length === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan={3}>-</TableCell>
                    </TableRow>
                  )}
                  {devices.map((dev) => (
                    <USBBatchUploadRow key={dev.mac || dev.name} device={dev} ncodeAllocation={ncodeAllocation} projectSubmissionList={projectSubmissionList} 
                    projectCode={projectCode}
										usbAssignedUserMapper={usbAssignedUserMapper}
                    studentInfos={studentInfos}
                    onReadyChange={(mac: string, ready: boolean) => {
                      if (!mac) return;
                      const setRef = readyDeviceMacsRef.current;
                      if (ready) {
                        if (!setRef.has(mac)) {
                          setRef.add(mac);
                          setNumOfReadyToUploadPen(setRef.size);
                        }
                      } else {
                        if (setRef.delete(mac)) {
                          setNumOfReadyToUploadPen(setRef.size);
                        }
                      }
                    }}
                    onDuplicateChange={(mac: string, isDuplicate: boolean) => {
                      if (!mac) return;
                      const setRef = duplicateDeviceMacsRef.current;
                      if (isDuplicate) {
                        if (!setRef.has(mac)) {
                          setRef.add(mac);
                          setNumOfDuplicateSelection(setRef.size);
                        }
                      } else {
                        if (setRef.delete(mac)) {
                          setNumOfDuplicateSelection(setRef.size);
                        }
                      }
                    }}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainerWrap>
            {numOfDuplicateSelection > 0 && (
              <Stack mt={2} alignItems="center" justifyContent="center" sx={{ width: '70%' }}>
                <Typography variant="h6" sx={{ color: '#FF0000', textAlign: 'center' }}>
                  {i18next.t("오류가 감지된 펜이 있습니다. 오류가 발생한 펜을 크래들에서 분리한 뒤, 데이터를 전송해주세요.")}
                </Typography>
              </Stack>
            )}
          </TableWrap>
          <SendingPanel
            i18next={i18next}
            sendingStatus={sendingStatus}
            onClose={onClose}
            onSend={handleSendClick}
            numOfReadyToUploadPen={numOfReadyToUploadPen}
            hasDuplicateSelection={numOfDuplicateSelection > 0}
            currentIndex={pipeline.current}
            total={pipeline.total}
            itemsPerPhase={itemsPerPhase}
          />
        </Stack>
      </Dialog>

      {/* Error/Retry dialog */}
      <Dialog
        open={isErrorDialogOpen}
        onClose={() => setIsErrorDialogOpen(false)}
      >
        <Stack p={3} spacing={3} alignItems="center" justifyContent="center" sx={{ width: "520px" }}>
          <Typography variant="body1">일부 항목 처리에 실패했습니다. 재시도 하시겠습니까?</Typography>
          <ButtonWrap>
            <Button size="large" variant="outlined" onClick={() => { 
              setIsErrorDialogOpen(false); 
              handleCompleteDialogClose(); 
            }}>
              {i18next.t("취소")}
            </Button>
            <Button size="large" variant="contained" style={{backgroundColor: "#025949" }} onClick={handleRetryFailed}>
              {i18next.t("재시도")}
            </Button>
          </ButtonWrap>
        </Stack>
      </Dialog>

      <Dialog
        open={isCompleteDialogOpen}
        onClose={handleCompleteDialogClose}
      >
        <Stack p={3} spacing={3} alignItems="center" justifyContent="center" sx={{ width: "500px", height: "200px" }}>
          <Typography variant="body1">필기데이터 변환이 완료되었습니다.</Typography>
          <ButtonWrap>
            <Button size="large" variant="contained" style={{backgroundColor: "#025949" }} onClick={handleCompleteDialogClose}>
              {i18next.t("확인")}
            </Button>
          </ButtonWrap>
        </Stack>
      </Dialog>
    </>
  );
}

